import React, { useEffect, useState } from 'react'
import { Form } from 'react-bootstrap';
import { getCmTrophyVidhanSabhas } from '../../../services/adminApiService/cmTrophyApi/cmTrophyApi';

const CmTrophyVidhanSabhaFilter = ({ className = " ", value, onChange, sansadId }) => {
    const [vidhanSabhaList, setVidhanSabhaList] = useState([]);

    useEffect(() => {
        if (!sansadId) {
            setVidhanSabhaList([]);
            onChange("");
            return;
        }
        getCmTrophyVidhanSabhas(sansadId)
            .then((res) => setVidhanSabhaList(res?.data?.data || []))
            .catch(() => setVidhanSabhaList([]));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [sansadId]);

    return (
        <>
            <div className="">
                <Form.Select
                    value={value}
                    onChange={(e) => onChange(e.target.value)}
                    className={`me-2 ${className}`}
                    style={{ width: "100%", padding: "11px 50px 10px 11px" }}
                    disabled={!sansadId}
                > <option value="">All Vidhan Sabha</option>
                    {vidhanSabhaList.map((item) => {
                        return (
                            <option key={item.id} value={item.id}>{item?.name}</option>
                        )
                    })}
                </Form.Select>
            </div>
        </>
    )
}

export default CmTrophyVidhanSabhaFilter
